import React from "react";
import { EditFormComponent } from "src/components/edit-form";
import { WEEDS_EDIT_LIST_ITEMS } from "src/config/edit-form";
import { ISeedEditFormProps } from "./weed-edit-form-types";

export const WeedEditForm = (props: ISeedEditFormProps) => {
  const {
    editObjData,
    addToModifiedParams,
    uniqFamily,
    uniqGenus,
    uniqBioClass,
    uniqBioGroup,
    empty,
  } = props;

  const listItemsFunc = {
    family: uniqFamily,
    genus: uniqGenus,
    cladeClass: uniqBioClass,
    cladeGroup: uniqBioGroup,
  };
  // if (!editObjData) return null;

  return (
    <EditFormComponent
      editName="Сорняки"
      listItemsProp={WEEDS_EDIT_LIST_ITEMS}
      listItemsFunc={listItemsFunc}
      editObjData={editObjData}
      addToModifiedParams={addToModifiedParams}
      empty={empty}
    />
  );
};
